import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { AttributeEditor } from '@shared/model/attribute-editor';

@Injectable({
  providedIn: 'root'
})
export class AttributeEditorService {

  constructor(private http: HttpClient) { }

  getEditors():Observable<AttributeEditor[]>{
    return this.http.get<AttributeEditor[]>(`${environment.serviceApi}/editors`);
  }
  getMyEditors():Observable<AttributeEditor[]>{
    return this.http.get<AttributeEditor[]>(`${environment.serviceApi}/editors/mine`);
  }
  AddEditor(editor:AttributeEditor):Observable<AttributeEditor>{
  //  this.isStoreDirty=true;
    return this.http.post<AttributeEditor>(`${environment.serviceApi}/editors`,editor);
  }
  editEditor(id:string|number,editor:AttributeEditor):Observable<AttributeEditor>{
    //this.isStoreDirty=true;
    return this.http.put<AttributeEditor>(`${environment.serviceApi}/editors/${id}`,editor);
  }
  toggleActive(editor:AttributeEditor):Observable<AttributeEditor>{
    //this.isStoreDirty=true;
    return this.http.put<AttributeEditor>(`${environment.serviceApi}/editors/${editor.id}/changestatus`,editor);
  }
  deleteEditor(editor:AttributeEditor):Observable<Boolean>{
   // this.isStoreDirty=true;
    return this.http.delete<boolean>(`${environment.serviceApi}/editors/${editor.id}`);
  }

  getEditorInfo(id:string|number):Observable<AttributeEditor>{
    return this.http.get<AttributeEditor>(`${environment.serviceApi}/editors/${id}`);
  }
  /**
   * 
   * @param stageId Add Attribute to given stage
   * @param attributeId 
   * @param isEditable 
   */
  addEditorAttribute(stageId:string|number|undefined,attributeId:number|string|undefined,isEditable:boolean){
    return this.http.post<AttributeEditor>(`${environment.serviceApi}/editors/${stageId}/addattribute`,{id:attributeId,isEditable:isEditable});
  }
  /**
   * Change stage-attribute relationship
   * @param stageAttributeId 
   * @param isEditable 
   */
  updateStageAttribute(stageAttributeId:number|String,isEditable:boolean){
    return this.http.post<AttributeEditor>(`${environment.serviceApi}/editors/attribute`,{stageAttributeId:stageAttributeId,isEditable:isEditable});
  }
  /**
   * remove stage-attribute relationship
   * @param stageAttributeId 
   */
  deleteEditorAttribute(stageAttributeId:number|String):Observable<Boolean>{
    return this.http.delete<boolean>(`${environment.serviceApi}/editors/attribute/${stageAttributeId}`);
  }
  /**
   * Add user to Stage
   * @param stageId 
   * @param userName 
   */
  addEditorUser(stageId:number|string,userName:string){
    return this.http.post<AttributeEditor>(`${environment.serviceApi}/editors/${stageId}/adduser`,{username:userName});
  }
  deleteEditorUser(stageId:number|String,userName:string):Observable<Boolean>{
    return this.http.delete<boolean>(`${environment.serviceApi}/editors/${stageId}/user/${userName}`);
  }
}
